import React from "react";
import { useEffect, useState } from "react";
import { GetSalesByBeat, GetSalesByPerson, PostPaymentDue, PostPaymentDueByBeatwise } from "../../util/APIUtils";
import PaymentDueBody from "./PaymentDueBody";
import { useMemo } from "react";
import { LoadingOverlay } from "../../util/Helpers";
import PaymentDueBeatBody from "./PaymentDueBeatBody";

export default function PaymentDueBeat() {
  const [values, setValues] = useState({ name: "test" });
  const [trans, setTrans] = useState([]);
  const [block, setBlock] = useState(false);
  const [hide, setHide] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    loadReqData();
  }, []);

  const loadReqData = () => {
    setBlock(true);
    PostPaymentDueByBeatwise(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };

  const showSales = (row) => {
    let obj = { beatName: row.beatName };
    setBlock(true);
    GetSalesByBeat(obj).then((response) => {
      setItems(response);
      setBlock(false);
      setHide(!hide);
      setBlock(false);
    });
  };
  const Onback = () => {
    setHide(!hide);
  };
  const memoizedTrans = useMemo(() => trans, [trans]);
  const memoizedItems = useMemo(() => items, [items]);
  return (
    <div className="animated fadeIn">
      {block && <LoadingOverlay />}
      <PaymentDueBeatBody
        data={memoizedTrans}
        showSales={showSales}
        hide={hide}
        Onback={Onback}
        items={memoizedItems}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/PaymentDueBeat.js